module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/084-barbados-1fc7c648421ab1c536ca8c70b0ff80b3.svg";